import { render } from "./FileDropzone.vue?vue&type=template&id=d9cef296"
import script from "./FileDropzone.vue?vue&type=script&lang=js"
export * from "./FileDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/FileDropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d9cef296"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d9cef296', __exports__)) {
    api.reload('d9cef296', __exports__)
  }
  
  module.hot.accept("./FileDropzone.vue?vue&type=template&id=d9cef296", () => {
    api.rerender('d9cef296', render)
  })

}


export default __exports__